import React from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box
} from '@material-ui/core'

const MapBlocker = ({ missing = [], hints = [], onRetry }) => {
  return (
    <Dialog open fullWidth maxWidth="md" aria-labelledby="map-blocker-title">
      <DialogTitle id="map-blocker-title">No puedes usar el mapa todavía</DialogTitle>

      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          Faltan estos requisitos de configuración:
        </Typography>

        <List dense>
          {missing.map((item, i) => (
            <ListItem key={i}>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>

        {hints.length > 0 && (
          <>
            <Typography variant="body1" sx={{ mt: 2 }} gutterBottom>
              Sugerencias:
            </Typography>
            <List dense>
              {hints.map((hint, i) => (
                <ListItem key={i}>
                  <ListItemText primary={hint} />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Box display="flex" justifyContent="flex-end" width="100%">
          <Button variant="contained" color="primary" onClick={onRetry}>
            Reintentar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

MapBlocker.propTypes = {
  missing: PropTypes.arrayOf(PropTypes.string),
  hints: PropTypes.arrayOf(PropTypes.string),
  onRetry: PropTypes.func
}

export default MapBlocker
